import {activateSpinnerModal, deactivateSpinnerModal, coordinateModalShowBody, coordinateModalShowBodyReset, initializeModalControls, displayTargetModal, closeTargetParentModal} from './modals-control'

let giftsModal

let giftClassesObject = {}
let giftsAmountInfoContainerObj
let activeGiftClassObj = null, activeGiftClass;
let activeGiftAmount, activeFormattedGiftAmount, giftAmountObj;

let giftAmountDisplayContainerObj, customGiftAmountInputContainerObj

let customGiftAmountInputObj = null;
let giftAmountDisplayObj = null;

let customGiftActivator, giftCurrencyInfoObj, giftCurrency, giftCurrencySymbol; 

let validationErrorInfoObj;
let proceedToPaymentOptionsBtn, giftMessage;

let customGiftClassObj;


// Should Be self contained incase we need to move it or use it in other modules

window.addEventListener('load', function() {

    giftsModal =  document.getElementById("gifts-modal")

    if (giftsModal !== null) {
        console.log("document ready from gifts script")

        giftAmountDisplayContainerObj = document.getElementById("gift-amount-display-container")
        customGiftAmountInputContainerObj = document.getElementById("custom-gift-amount-input-container")

        // Set gift amount info container
        giftsAmountInfoContainerObj = document.getElementById("gifts-amount-info-container")

        giftAmountDisplayObj = document.getElementById("gift-amount-display")
        customGiftAmountInputObj = document.getElementById("custom-gift-amount")
        giftAmountObj = document.getElementById("gift-amount")

        // Add Event Listener for Custom Gift Amount Input
        customGiftAmountInputObj.addEventListener("input", setCustomGiftAmount)
        customGiftAmountInputObj.addEventListener("change", setCustomGiftAmount)
        customGiftAmountInputObj.addEventListener("focusout", setCustomGiftAmount)

        customGiftActivator = document.getElementById("activate-custom-gift-input")
        // Add Event Listener for activating Custom Gift Class Mode
        customGiftActivator.addEventListener("click", activateCustomGiftClassMode)

        validationErrorInfoObj = document.getElementById("validation-error-info")

        giftCurrencyInfoObj = document.getElementById("gift-currency-details")
        setGiftCurrencyInfo()

        proceedToPaymentOptionsBtn = document.getElementById("gift-proceed")
        proceedToPaymentOptionsBtn.addEventListener("click", validateGiftAmountBeforeProceeding)

        giftMessage = document.getElementById("gift-message")

        // https://bobbyhadz.com/blog/javascript-get-element-by-data-attribute
        customGiftClassObj = document.querySelector('[data-class="custom"]');

        // Add Event Listeners
        Array.from(document.getElementsByClassName('init-gifts-payment')).forEach(el => {
            el.addEventListener('click', handleInitGiftsPaymentEvent)
        });

        Array.from(document.getElementsByClassName('gift-class')).forEach(el => {
            el.addEventListener('click', setSelectedGiftClass)
        });

        /* Initialize Modals Control */
        // Get all modals and attach their event listeners
        initializeModalControls()
    }
})


export function validateGiftAmountBeforeProceeding(e) {
    // Prevent default actions
    e.preventDefault()

    if (isValidCustomGiftAmount()) {
        console.log("gift amount is validated: ", activeGiftAmount)
        closeTargetParentModal(e)
        // Display Associated Payment Options Modal
        displayTargetModal(e)

    }
    console.log("gift amount is not validated: ", activeGiftAmount)
    
}


export function setGiftCurrencyInfo() {
    if (giftCurrencyInfoObj !== null) {
        giftCurrency = giftCurrencyInfoObj.getAttribute('data-currency')
        giftCurrencySymbol = giftCurrencyInfoObj.getAttribute('data-currency_symbol')
    }
    console.log("gift currency: ", giftCurrency)
    console.log("gift currency symbol: ", giftCurrencySymbol)
}

export function setCustomGiftAmount() {

    // Get the value of Custom Gift Input and set it to gift amount
    let customGiftAmount = customGiftAmountInputObj.value
    giftAmountObj.value = customGiftAmount
    activeGiftAmount = customGiftAmount

    console.log("custom gift amount value: ", customGiftAmount)
    console.log("gift amount value from custom: ", giftAmountObj.value)
    console.log("active gift amount value from custom: ", activeGiftAmount)

}


export function setSelectedGiftClass(e) {

    // First of all, let the gift amount info container be open
    showGiftAmountInfoContainer()

    // A gift class has been clicked, set the amount and active gift class
    activeGiftClassObj = e.currentTarget
    activeGiftAmount = e.currentTarget.getAttribute('data-amount')
    activeFormattedGiftAmount = e.currentTarget.getAttribute('data-formatted_amount')
    activeGiftClass = e.currentTarget.getAttribute('data-class')
    activeGiftClass = activeGiftClass.toLowerCase()

    console.log("active formatted gift amount", activeFormattedGiftAmount)
    console.log("active gift class", activeGiftClass)

    // Reset the thick border display
    resetThickBorderDisplayForGiftClasses()

    // Add the thick border around it to visually activate it
    activeGiftClassObj.classList.add("border-green-600")

    // set gift amount (Attend to this later, maybe on change of custom gift amount input, set this) 
    giftAmountObj.value = activeGiftAmount

    console.log("preset gift amount: ", activeGiftAmount)
    console.log("preset gift amount value: ", giftAmountObj.value)
    console.log("preset gift amount object: ", giftAmountObj)

    // If the class is custom, then display the custom amount input and focus it
    if (activeGiftClass.includes("custom")) {
        setCustomGiftClassMode()        
    } else{  
        // Else, display the gift amount display input and don't focus it    
        setPresetGiftClassMode()
    }
}

export function setAndDisplayCustomAmountValidationError(msg) {
    validationErrorInfoObj.textContent = msg
    validationErrorInfoObj.classList.remove("hidden")
}

export function resetAndHideCustomAmountValidationError() {
    validationErrorInfoObj.textContent = ""
    validationErrorInfoObj.classList.add("hidden")
}

export function isValidCustomGiftAmount() {
    if (activeGiftClass.includes("custom")) {
        console.log("validating custom gift amount: ", activeGiftAmount)
        let effectiveGiftAmount, msg
         
        // Try to convert active GiftAmount to Number
        try {
            effectiveGiftAmount = Number(activeGiftAmount)
        } catch(error) {
            msg = "invalid amount, kindly clear the input and type in only numbers"
            console.error(err)
            console.log("invalid activeGiftAmount: ", activeGiftAmount )
            console.log(msg)

            // Show error, return false
            setAndDisplayCustomAmountValidationError(msg)

            setTimeout(function(){
                resetAndHideCustomAmountValidationError()
            }, 3000)
            return false
        }

        // validate that input is valid and numeric
        if (effectiveGiftAmount == "" || effectiveGiftAmount <= 0 ) {
            msg = "gift amount is empty or zero"
            // Show error, return false
            setAndDisplayCustomAmountValidationError(msg)

            setTimeout(function(){
                resetAndHideCustomAmountValidationError()
            }, 3000)

            return false
        }

        // Check if Gift Currency is NGN and if amount is >= 1000
        if (giftCurrency == "NGN") {
            console.log("validating NGN amount")
            if (effectiveGiftAmount < 1000) {
                // Show error, return false
                msg = "To allow for smooth payment processing, Amount should not be less than 1,000 Naira"
                setAndDisplayCustomAmountValidationError(msg)

                setTimeout(function(){
                    resetAndHideCustomAmountValidationError()
                }, 3000)
    
                return false
            }
        }

        return true;
    } 
    
    console.log("active gift class is: ", activeGiftClass)

    return true;
}

export async function handleInitGiftsPaymentEvent(e) {


    // Validate Custom Amount     
    if (!isValidCustomGiftAmount()) {
        return false
    } 

    // Disable scrolling on document body (function displays a spinner modal)
    coordinateModalShowBody()
  
    // Disable element for network request
    e.currentTarget.disabled = true
    // Keep a Copy of current Event Target
    let currentEventTarget = e.currentTarget 
  
    // https://byexample.xyz/javascript/tryCatchThrow/
    try {
      // Network requests might trigger an error (though already handled)
    
      activateSpinnerModal()
  
      // Call function
      await processGiftPaymentRequest(e) 
      
    } catch (error) {
      // Only runs when there is an error/exception
  
    } finally {
      // Code here always runs. Doesn't matter if there was an error or not.
      
      // Hide Spinner No Matter What
        deactivateSpinnerModal()
  
        // Re-Enable Button
        currentEventTarget.disabled = false;

        coordinateModalShowBodyReset()
    }
  
}

// gift-amount-container
export function BuildGiftClassObject(elem) {
    // Remove space from gift class data-
    // No longer required, different approach employed
}

export function activateCustomGiftClassMode() {
    // Hide Preset Amount Display
    setCustomGiftClassMode()
    // Clear clicked gift classes border and add it to custom class
    // Reset the thick border display
    resetThickBorderDisplayForGiftClasses()

    // Add the thick border around it to visually activate it
    if (customGiftClassObj !== null) {
        customGiftClassObj.classList.add("border-green-600")
        activeGiftClassObj = "custom"

    }

}

export function setCustomGiftClassMode() {
    // Hide Preset Amount Display
    hideGiftAmountDisplay()

    // Empty Custom Amount Input
    customGiftAmountInputObj.value = ""
    giftAmountObj.value = ""

    // Show Custom Amount Input
    showCustomGiftAmountInput()

    // set Custom Gift Class Active
    // activeGiftClass = "custom" // already set 
}

export function setPresetGiftClassMode() {
    // Hide Custom Gift Amount Input Container 
    hideCustomGiftAmountInput()

    // Set Display Formatted Amount
    giftAmountDisplayObj.value = activeFormattedGiftAmount 
    // Already set before now though
    giftAmountObj.value = activeGiftAmount
    
    // show preset gift amount display container
    showGiftAmountDisplay()

    // Set Preset Gift Amount as Active
    // activeGiftClass = "custom" // Already set
}

export function showGiftAmountInfoContainer() {
    if (giftsAmountInfoContainerObj !== null ){
        giftsAmountInfoContainerObj.classList.remove("hidden")
        giftsAmountInfoContainerObj.classList.add("flex")    
    }
}

export function showCustomGiftAmountInput() {
    if (customGiftAmountInputContainerObj !== null ){
        customGiftAmountInputContainerObj.classList.remove("hidden")
        customGiftAmountInputContainerObj.classList.add("flex")
    }
}

export function hideCustomGiftAmountInput() {
    if (customGiftAmountInputContainerObj !== null ){
        customGiftAmountInputContainerObj.classList.remove("flex")
        customGiftAmountInputContainerObj.classList.add("hidden")
    }
}

export function showGiftAmountDisplay() {
    if (giftAmountDisplayContainerObj !== null ){
        giftAmountDisplayContainerObj.classList.remove("hidden")
        giftAmountDisplayContainerObj.classList.add("flex")
    }
}

export function hideGiftAmountDisplay() {
    if (giftAmountDisplayContainerObj !== null ){
        giftAmountDisplayContainerObj.classList.remove("flex")
        giftAmountDisplayContainerObj.classList.add("hidden")
    }
}

export function resetThickBorderDisplayForGiftClasses(){
    Array.from(document.getElementsByClassName('gift-class')).forEach(el => {
        el.classList.remove("border-green-500")
        el.classList.remove("border-green-600")
    });
}


export async function processGiftPaymentRequest(e) {

    const gateway = e.currentTarget.getAttribute('data-gateway')
    console.log("payment gateway: ", gateway)
  
    let paymentMethod = gateway.includes("bank") ? "bank" : "gateway"
    let ipAddressInput = document.getElementById("request-ip-address")
    let ipAddress = (ipAddressInput !== null)? ipAddressInput.value : ""

  
    let response = {};
    
    let giftPayment = {
      gift_class: activeGiftClass,
      gift_amount: activeGiftAmount,
      gift_currency: giftCurrency,
      gift_message: giftMessage.value,
      gift_type: "gift",
      payment_method: paymentMethod, 
      payment_gateway: gateway,
      ip_address: ipAddress,     
    }
  
    console.log(giftPayment)
    
    response = await postGiftPaymentRequest(giftPayment)
    console.log(response)
  
    // Now, we have the reponse
    if (response.hasOwnProperty('data')) {
  
      let transactionID =  response.data.transaction_id;
      let giftID =  response.data.gift_id;
      let userID =  response.data.user_id;
      // let paymentID =  response.data.payment_id;
      let formattedTransferAmount = response.data.formatted_payment_amount;
      
      // Build the Transaction Details and Display on UI
      /*
        <span id="gift-details" class=" transaction-id text-sm font-bold">Transaction ID:
            txn-HD8DLI2DHLSLWSH89J8, UserID: txn-HD8DLI2DHLSLWSH89J8, GiftID: txn-HD8DLI2DHLSLWSH89J8, Amount: NGN 250,000</span>
      */
      let formattedTransactionDetails = "";
      formattedTransactionDetails += 'Transaction ID: ' + transactionID;
      formattedTransactionDetails += ', User ID: ' + userID;
      formattedTransactionDetails += ', Gift ID: ' + giftID;
      formattedTransactionDetails += ', Amount: ' + formattedTransferAmount;
  
  
      // Foreach gift-transfer-amount,
      Array.from(document.getElementsByClassName('gift-transfer-amount')).forEach(el => {
        el.textContent = formattedTransferAmount;
      })
      
      // Foreach gift-details, add the details
      Array.from(document.getElementsByClassName('gift-details')).forEach(el => {
          el.textContent = formattedTransactionDetails;
        })
  
      } else {
        console.log("response object doesn't contain data object", response)
    }   
  
}
  
  // https://rapidapi.com/guides/error-handling-fetch
  // https://stackoverflow.com/questions/39735496/redirect-after-a-fetch-post-call
async function postGiftPaymentRequest(giftPaymentRequest) {
    // Code to submit the giftPayment to the server
    // Here, we'll use the fetch() function to POST the data to an API endpoint
    return fetch('/payment/gifts', {
        method: 'POST',
        body: JSON.stringify(giftPaymentRequest),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
            throw new Error('Server error');
        }
        return response.json();
    })
    .then(data => {
        // Handle the response from the server
        console.log(data);
        if (!data.error) {
            console.log(data.message) 
            
            if (!(data.data.payment_method.includes("bank")) && (data.data.payment_link !== "")) {
            // must be a gateway payment
            window.location.replace(data.data.payment_link)
            }
            return data;
        } else {
            console.log(data.message)
            return data;          
        }
    })
    .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });

}